import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import {
  addLane,
  deleteLane,
  editLane,
  loadLane,
} from '../actions/boardLane';
import { fetchAllData } from '../api/boardSettings';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function createLane(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardLane`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(addLane({ lane: json }));
            dispatch(fetchAllData());
            dispatch(push('/pages/boardsettings'));
            dispatch(notify({
              title: 'Add New Lane',
              message: 'Lane added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Lane',
            message: 'Failed to add new lane',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function removeLane(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardLane/deleteLane/${data.id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(deleteLane({ id: data.id }));
            dispatch(fetchAllData());
            dispatch(notify({
              title: 'Delete Lane',
              message: 'Lane deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Delete Lane',
            message: 'Failed to delete lane',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function refreshLane(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardLane/${id}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(editLane({ lane: json }));
            dispatch(fetchAllData());
            dispatch(push('/pages/boardsettings'));
            dispatch(notify({
              title: 'Edit Lane',
              message: 'Lane edited successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Edit Lane',
            message: 'Failed to edit stage',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function fetchLaneById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/boardLane/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadLane({ lane: json }));
          }
        })
    }
  }
}


// WEBPACK FOOTER //
// ./src/api/boardLane.js